<template>
  <div class="wrapper">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'default-container',
};
</script>

<style>
.wrapper {
  flex-grow: 1;
  background-color: #eef7fe;
}

.v-dialog>.v-card>.v-card__text,
.v-dialog>.v-card>.v-card__title {
  padding-left: 16px;
  padding-right: 16px;
}
</style>
